import { API_AUTH } from ".././common";

const ThietLapHienThiApi = {
  thietLapDanhSachCamDo: (iLevel) =>
    API_AUTH.get(`thietlaphienthi/danhsachcamdo`, {}),

  saveThietLapDanhSachCamDo: (params) =>
    API_AUTH.post("thietlaphienthi/savedanhsachcamdo", params),

  thietLapDanhSachTinChap: (iLevel) =>
    API_AUTH.get(`thietlaphienthi/danhsachtinchap`, {}),

  saveThietLapDanhSachTinChap: (params) =>
    API_AUTH.post("thietlaphienthi/savedanhsachtinchap", params),

  thietLapDanhSachTraGop: (iLevel) =>
    API_AUTH.get(`thietlaphienthi/danhsachtragop`, {}),

  saveThietLapDanhSachTraGop: (params) =>
    API_AUTH.post("thietlaphienthi/savedanhsachtragop", params),

  thietLapDanhSachNoPhaiThu: (iLevel) =>
    API_AUTH.get(`thietlaphienthi/danhsachnophaithu`, {}),

  saveThietLapDanhSachNoPhaiThu: (params) =>
    API_AUTH.post("thietlaphienthi/savedanhsachnophaithu", params),

    thietLapDongLai: (iLevel) =>
    API_AUTH.get(`thietlaphienthi/danhsachdonglai`, {}),

  saveThietLapDongLai: (params) =>
    API_AUTH.post("thietlaphienthi/savedonglai", params),

    thietLapDanhSachNhanVay: (iLevel) =>
    API_AUTH.get(`thietlaphienthi/danhsachnhanvay`, {}),

  saveThietLapDanhSachNhanVay: (params) =>
    API_AUTH.post("thietlaphienthi/savedanhsachnhanvay", params),
};
export default ThietLapHienThiApi;
